import styled from 'styled-components';

// import theme helpers
import { getBreakpoint } from '../../../util/theme';

const ScrollPixel = styled.div`
  position: absolute;
  top: 175px;
  left: 0;

  height: 1px;
  width: 1px;

  @media (min-width: ${getBreakpoint('lg')}) {
    top: 75px;
  }
`;

export default ScrollPixel;
